__turbopack_context__.v({
  "crumbItem": "LO1tQW_crumbItem",
  "crumbText": "LO1tQW_crumbText",
  "wrapper": "LO1tQW_wrapper",
});
